<mat-spinner [diameter]="100"></mat-spinner>

